import { render, staticRenderFns } from "./DepartList2.vue?vue&type=template&id=3073e14c&scoped=true"
import script from "./DepartList2.vue?vue&type=script&lang=js"
export * from "./DepartList2.vue?vue&type=script&lang=js"
import style0 from "./DepartList2.vue?vue&type=style&index=0&id=3073e14c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3073e14c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3073e14c')) {
      api.createRecord('3073e14c', component.options)
    } else {
      api.reload('3073e14c', component.options)
    }
    module.hot.accept("./DepartList2.vue?vue&type=template&id=3073e14c&scoped=true", function () {
      api.rerender('3073e14c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/DepartList2.vue"
export default component.exports